module.exports = __webpack_public_path__ + "static/media/12.2e64cf2e.JPG";